import {BannerLinkTypeEnums} from '../enums/banner-enums';
import {GrBanner} from '../interfaces/banners-interfaces';

export const PasswordRegex = '^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+{}|:"<>?`\\-=[\\]\\\\;\',./]).{8,}$';
export const EmailRegex = '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$';
export const PhoneRegex = '^0\\d{6,10}$';
export const MobileRegex = '^06\\d{7,8}$';
export const UrlRegex = /https?:\/\/(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?/;
export const PibRegex = '\\b\\d{8}\\b';
export const MbRegex = '\\b\\d{9}\\b';
export const BankAccountRegex = '^[0-9]{18}$';
export const TimeRegex = /^\\d{2}:\\d{2}$/;
export const DigitRegex = '^\\d+(\\.\\d{2})?$';
export const JmbgRegex = '^\\d{13}$';

export const Units = [
  {unit: 'Komad', short: 'kom'},
  {unit: 'Sat', short: 'h'}
];
export const PlayRoomUnits = [
  {unit: 'Po komadu', short: 'piece'},
  {unit: 'Po satu', short: 'time'},
  {unit: 'Po kolicini', short: 'quantity'}
];
export const UnitsForCake = [
  {unit: 'Kilogram', short: 'kg'},
  {unit: 'Gram', short: 'g'},
  {unit: 'Komad', short: 'kom'},
];

export const WorkDays = {
  monday: 'Ponedeljak',
  tuesday: 'Utorak',
  wednesday: 'Sreda',
  thursday: 'Četvrtak',
  friday: 'Petak',
  saturday: 'Subota',
  sunday: 'Nedelja',
};

export const DaysOfWeek = [
  {
    dayForView: 'Ponedeljak',
    dayForDB: 'monday',
    number: 1
  },
  {
    dayForView: 'Utorak',
    dayForDB: 'tuesday',
    number: 2
  },
  {
    dayForView: 'Sreda',
    dayForDB: 'wednesday',
    number: 3
  },
  {
    dayForView: 'Četvrtak',
    dayForDB: 'thursday',
    number: 4
  },
  {
    dayForView: 'Petak',
    dayForDB: 'friday',
    number: 5
  },
  {
    dayForView: 'Subota',
    dayForDB: 'saturday',
    number: 6
  },
  {
    dayForView: 'Nedelja',
    dayForDB: 'sunday',
    number: 0
  }
];


export const BusinessCategories = [
  {id: 1, name: 'Igraonica'},
  {id: 2, name: 'Dekoracija'},
  {id: 3, name: 'Ketering'},
  {id: 4, name: 'Animatori'},
  {id: 5, name: 'Fotograf'},
  {id: 6, name: 'Torte'},
  {id: 7, name: 'Pokloni'}
];

export const LandingBusinessCategories = [
  {id: 1, name: 'Igraonica'},
  {id: 7, name: 'Pokloni'},
  {id: 3, name: 'Ketering'},
  {id: 4, name: 'Animatori'},
  {id: 5, name: 'Fotograf'},
  {id: 6, name: 'Torte'},
  {id: 2, name: 'Dekoracija'}
];

export const DefaultABanners: GrBanner[] = [
  {
    id: 1,
    image: {full_path: '../../../../assets/images/landing/banners/backBanner1.png'},
    link_type: BannerLinkTypeEnums.external,
    link: 'https://mojrodjendan.rs/landing/contact',
    type: '',
    active: true,
    created_at: '',
    updated_at: '',
    position: 1,
    name: 'Dekoracije',
    description: 'Pretvori prostor u čarobnu bajku uz balone, tematske setove i personalizovane detalje.'
  },
  {
    id: 2,
    image: {full_path: '../../../../assets/images/landing/banners/backBanner2.png'},
    link_type: BannerLinkTypeEnums.external,
    link: 'https://mojrodjendan.rs/landing/contact',
    type: '',
    active: true,
    created_at: '',
    updated_at: '',
    position: 2,
    name: 'Pokloni',
    description: 'Izaberi savršen poklon sa liste želja i obraduј slavljenika bez nagađanja.'
  },
  {
    id: 3,
    image: {full_path: '../../../../assets/images/landing/banners/backBanner3.png'},
    link_type: BannerLinkTypeEnums.external,
    link: 'https://mojrodjendan.rs/landing/contact',
    type: '',
    active: true,
    created_at: '',
    updated_at: '',
    position: 3,
    name: 'Ketering',
    description: 'Ukusna hrana i poslastice za male i velike goste, spremne za serviranje.'
  },
  {
    id: 4,
    image: {full_path: '../../../../assets/images/landing/banners/backBanner4.png'},
    link_type: BannerLinkTypeEnums.external,
    link: 'https://mojrodjendan.rs/landing/contact',
    type: 'Igraonica',
    active: true,
    created_at: '',
    updated_at: '',
    position: 4,
    name: 'Igraonice',
    description: 'Bezbedan i zabavan prostor gde deca uživaju, a roditelji se opuštaju.'
  },
  {
    id: 5,
    image: {full_path: '../../../../assets/images/landing/banners/backBanner5.png'},
    link_type: BannerLinkTypeEnums.external,
    link: 'https://mojrodjendan.rs/landing/contact',
    type: '',
    active: true,
    created_at: '',
    updated_at: '',
    position: 5,
    name: 'Torte',
    description: 'Personalizovane torte po ukusu i želji — savršeni šlag na kraju proslave.'
  },
  {
    id: 6,
    image: {full_path: '../../../../assets/images/landing/banners/backBanner6.png'},
    link_type: BannerLinkTypeEnums.external,
    link: 'https://mojrodjendan.rs/landing/contact',
    type: '',
    active: true,
    created_at: '',
    updated_at: '',
    position: 6,
    name: 'Fotografi',
    description: 'Zabeleži svaki osmeh i trenutak koji želiš da pamtiš zauvek.'
  },
  {
    id: 7,
    image: {full_path: '../../../../assets/images/landing/banners/backBanner7.png'},
    link_type: BannerLinkTypeEnums.external,
    link: 'https://mojrodjendan.rs/landing/contact',
    type: '',
    active: true,
    created_at: '',
    updated_at: '',
    position: 7,
    name: 'Animatori',
    description: 'Veseli junaci koji donose smeh, igre i nezaboravnu zabavu deci.'
  }
];
